import { ToastContainer } from "react-toastify";
import SimpleBottomNavigation from "../components/FooterNavbar";
import CopyRightPatient from "./../components/CopyRightPatient";
import PatientHeader from "./../components/PatientHeader";

function Layout({ children }) {
  return (
    <>
      <PatientHeader />
      {children}
      {/* <CopyRightPatient /> */}
      <ToastContainer />
      <SimpleBottomNavigation />
    </>
  );
}

export default Layout;
